import React from 'react';
import TimelineItem, { TimelineItemProps } from 'components/TimelineItem';
import { LogDescription } from 'ethers/lib/utils';
import useConnectedAccount from 'hooks/useConnectedAccount';
import useTranslate from 'hooks/useTranslate';
import { Text } from '@chakra-ui/react';
import { getShortenedAddress } from 'utils/walletUtils';

export interface TokenTransferEventTimelineItemProps
  extends Omit<TimelineItemProps, 'title'> {
  type: 'jar' | 'bear';
  log: LogDescription;
}

const TokenTransferEventTimelineItem: React.FC<
  TokenTransferEventTimelineItemProps
> = ({ type, log, ...rest }) => {
  const translate = useTranslate();
  const [accountAddress] = useConnectedAccount();
  const isReceived = log.args.to === accountAddress;
  const translationKeyPrefix = `timeline:events:${type}:${
    isReceived ? 'received' : 'sent'
  }`;

  return (
    <TimelineItem title={translate(`${translationKeyPrefix}:title`)} {...rest}>
      <Text
        dangerouslySetInnerHTML={{
          __html: translate(`${translationKeyPrefix}:description`, {
            id: log.args.tokenId,
            from: getShortenedAddress(log.args.from),
            to: getShortenedAddress(log.args.to),
          }),
        }}
      />
    </TimelineItem>
  );
};

export default TokenTransferEventTimelineItem;
